import type {
  TPaystubSnapshotReasonCode,
  TPaystubSnapshotRevisionType,
} from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export interface IPaystubSnapshotRevisionSummary {
  readonly paystubSnapshotRevisionID: string;
  readonly seq: number;
  readonly type: TPaystubSnapshotRevisionType;
  readonly reasonCode: TPaystubSnapshotReasonCode;
  readonly notes?: string;
  readonly createdAt?: string;
}

export interface IGetPaystubSnapshotRevisionsResponse {
  readonly hasSnapshot: boolean;
  readonly baselineCreatedAt: string | null;
  readonly revisions: IPaystubSnapshotRevisionSummary[];
}

export const getPaystubSnapshotRevisions = (axios: IAxiosInstance) => {
  return async ({
    companyID,
    employeeCheckID,
  }: {
    readonly companyID: string;
    readonly employeeCheckID: string;
  }): Promise<IGetPaystubSnapshotRevisionsResponse> => {
    const response = await axios.noRetry.get<
      IApiResponse<IGetPaystubSnapshotRevisionsResponse>
    >(
      `/api/paystub-snapshots/${encodeURIComponent(employeeCheckID)}/revisions`,
      { params: { companyID } }
    );
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Failed to fetch paystub snapshot revisions");
  };
};
